import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../Home/Navbar';
import "./Dashboard.css"
import Viewusers from './Viewusers';
import PostTemplate from "./PostTemplate"
import ReactPaginate from 'react-paginate';
import ActionCenter from './ActionCenter';
import END_POINT from '../../END_POINT';

const Dashboard = () => {
    const [post, setPost] = useState([]);
    const [post1, setPost1] = useState([]);
    const [state, setState] = useState(1);
    const navigate = useNavigate();
    const handleSignout = () => {
        localStorage.removeItem("Admin");
        navigate("/");
    }
    // userspart start
    const [users, setUsers] = useState([]);
    useEffect(() => {
      if(!JSON.parse(localStorage.getItem("Admin"))){
          navigate("/adminlogin")
      }
    }, []);
    
    useEffect(async() => {
        const res=await fetch(`${END_POINT}/auth/getUser`)
        .then(res=>res.json())
        .then(data=>{
            
            setUsers(data)
        })
    }, []);
    
    // userspart end

    useEffect(async () => {
        
        const res = await fetch(`${END_POINT}/post/getPost`)
            .then(res => res.json())
            .then(data => {
                
                const newArr = data.filter((data1) => {
                    if (data1.isChecked) return true
                })
                newArr.reverse()
                setPost1(newArr)
                setPost(newArr)
            })
    }, []);
    const usersPerPage=3
    const pageCount=Math.ceil(post1.length/3)
    const [pageNumber, setPageNumber] = useState(0);
    const pagesVisited=pageNumber*usersPerPage;
    const changePage=({selected})=>{
      setPageNumber(selected)
    }
    // search
    const [search, setSearch] = useState('');
    const searchKeyword=(e)=>{
        // console.log(e.target.value);
        setSearch(e.target.value);
        
        const filteredArray=post.filter(data=>{
            if(data.title.toLowerCase().includes(e.target.value.toLowerCase())||data.author.first.toLowerCase().includes(e.target.value.toLowerCase())||data.author.email.toLowerCase().includes(e.target.value.toLowerCase())){
                return true;
            }
            else{
                return false;
            }
        })
         setPost1(filteredArray);
    }

    return (
        <div className=''>
            <Navbar />

            <div className="row dashboard">
                <div
                    className="col-sm-2 sidenav my-3">
                    <h4 onClick={() => setState(1)} className={state == 1 ? "navbox bc" : "navbox"}>Dashboard</h4>
                    <h4 onClick={() => setState(2)} className={state == 2 ? "navbox bc" : "navbox"}>View User</h4>
                    <h4 onClick={() => setState(3)} className={state == 3 ? "navbox bc" : "navbox"}>View Post</h4>
                    <h4 onClick={() => setState(4)} className={state == 4 ? "navbox bc" : "navbox"}>Control Panel</h4>
                    <h4 onClick={handleSignout} className="navbox">Signout</h4>

                </div>
                {/* dashboard starts here */}
                {state == 1 ?
                    <div className="col-sm-10 dashspace my-3">
                        <div className="dashboxparent d-md-flex justify-content-around">
                            <div className="dashbox">
                                <h3>Total User: {users.length}</h3>
                            </div>
                            <div className="dashbox">
                                <h3>Total Post: {post.length}</h3>
                            </div>
                        </div>

                    </div>
                    : null}
                {/* dashboard home ends here */}
                {state == 2 ?
                    <div className="col-sm-10 dashspace my-3">
                    
                    <Viewusers data={users}  />
                           
                        
                    </div>
                    : null
                }
                {state == 3 ?
                    <div className="col-sm-10 dashspace my-3">
                        <input onChange={searchKeyword} value={search}  placeholder='Search blogs by title, author' type="search" className="form-control bg-dark text-white" id="datatable-search-input"/>
                        <ReactPaginate
        previousLabel="Previous"
        nextLabel="Next"
        pageCount={pageCount}
        onPageChange={changePage}
        pageClassName="page-item"
        containerClassName="pagination flex-wrap pagination-md justify-content-center"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        disabledClassname={"disabledBtns"}
        activeLinkClassName="active"
        renderOnZeroPageCount={null}
        />
                        {post1.length ? <div className="">
                            {post1.slice(pagesVisited, pagesVisited + usersPerPage).map((data, index) => {
                                return (
                                    <div className='' key={index}>
                                        {data.isChecked && data.author && <PostTemplate data={data} setPost1={setPost1} setPost={setPost} key={index} />}
                                    </div>

                                )
                            })}
                        </div> :
                            <h2>No Posts</h2>
                        }
                    </div>
                    : null
                }
                {state==4?
                <div className="col-sm-10 dashspace my-3">
                <ActionCenter data={users} setUsers={setUsers}/>


                </div>:null
                
                }
            </div>
        </div>
    )
};

export default Dashboard;
